import { ActionIcon, Group, GroupProps, Text } from "@mantine/core"
import { IconHeart } from "@tabler/icons-react"
import { useChatToggleReaction } from "@/orval/gen"
import { showErrorNotification } from "@/utils/form-submission-notifications"

interface Props extends GroupProps {
  reactionCount: number
  messageId: number
  userReacted: boolean
}

export function ReactionPillGroup({
  reactionCount,
  messageId,
  userReacted,
  ...props
}: Props) {
  const { mutateAsync: toggleReaction } = useChatToggleReaction({
    mutation: { onError: showErrorNotification },
  })

  return (
    <Group gap="xs" {...props}>
      <ActionIcon
        onMouseDown={(evt) => {
          evt.stopPropagation()
        }}
        onClick={async (evt) => {
          evt.stopPropagation()
          toggleReaction({ params: { messageId } })
        }}
        variant={"transparent"}
      >
        <IconHeart
          fill={userReacted ? "var(--mantine-primary-color-filled)" : "none"}
        />
      </ActionIcon>
      <Text>{reactionCount}</Text>
    </Group>
  )
}
